module.exports = __webpack_public_path__ + "static/9-18bd1ad0b2c07b8af3262da9724d69b3.jpg";